import styled from 'styled-components'

export const Wrapper = styled.button`
  display: grid;
  place-items: center;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 18px;
  cursor: pointer;
  background: none;
  border: none;
`

export const VoteContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  `
